export const BREAKPOINTS = {
  tablet: 768,
} as const;
